import { render, staticRenderFns } from "./company-info.vue?vue&type=template&id=0b2861ab&scoped=true"
import script from "./company-info.vue?vue&type=script&lang=js"
export * from "./company-info.vue?vue&type=script&lang=js"
import style0 from "./company-info.vue?vue&type=style&index=0&id=0b2861ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2861ab",
  null
  
)

export default component.exports